export const FETCH_OBJECTDATA = "FETCH_OBJECTDATA";
export const FETCH_OBJECTDATA_SUCCESS = "FETCH_OBJECTDATA_SUCCESS";
export const FETCH_OBJECTDATA_ERROR = "FETCH_OBJECTDATA_ERROR";

export const FETCH_REALESTATE = "FETCH_REALESTATE";
export const FETCH_REALESTATE_SUCCESS = "FETCH_REALESTATE_SUCCESS";
export const FETCH_REALESTATE_ERROR = "FETCH_REALESTATE_ERROR";

export const FETCH_PREMISES_SUCCESS = "FETCH_PREMISES_SUCCESS";
export const FETCH_PREMISES_ERROR = "FETCH_PREMISES_ERROR";

export const FETCH_RESIDENCE_SUCCESS = "FETCH_RESIDENCE_SUCCESS";
export const FETCH_RESIDENCE_ERROR = "FETCH_RESIDENCE_ERROR";

export const VIEWSTATE_SET = "VIEWSTATE_SET";

export const FETCH_AREA_FILTERS = "FETCH_AREA_FILTERS";
export const FETCH_AREA_FILTERS_SUCCESS = "FETCH_AREA_FILTERS_SUCCESS";
export const FETCH_AREA_FILTERS_ERROR = "FETCH_AREA_FILTERS_ERROR";

export const FETCH_RENT_FILTERS = "FETCH_RENT_FILTERS";
export const FETCH_RENT_FILTERS_SUCCESS = "FETCH_RENT_FILTERS_SUCCESS";
export const FETCH_RENT_FILTERS_ERROR = "FETCH_RENT_FILTERS_ERROR";

export const FETCH_SEARCH_FILTERS = "FETCH_SEARCH_FILTERS";
export const FETCH_SEARCH_FILTERS_SUCCESS = "FETCH_SEARCH_FILTERS_SUCCESS";
export const FETCH_SEARCH_FILTERS_ERROR = "FETCH_SEARCH_FILTERS_ERROR";

export const EMPTYOBJECTSTATE_SET = "EMPTYOBJECTSTATE_SET";

export const FETCH_GLOBAL_SEARCH = "FETCH_GLOBAL_SEARCH";
export const FETCH_GLOBAL_SEARCH_SUCCESS = "FETCH_GLOBAL_SEARCH_SUCCESS";
export const FETCH_GLOBAL_SEARCH_ERROR = "FETCH_GLOBAL_SEARCH_ERROR";



// WEBPACK FOOTER //
// ./src/js/constants/actionTypes.js